import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  textModalContainer: {
    padding: "0px 0px 20px 0px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxWidth: "520px",
  },

  bulletList: {
    margin: 0,
    paddingLeft: "18px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
});

export default useStyles;
